import React, { useCallback, useContext, useEffect, useState } from "react";
import { Container } from "components";
import Breadcrumb from "components/molecules/Breadcrumb";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getData, putData } from "actions";
import { API_URL_workflowClose } from "constants/api";
import { workflowCloseReducers } from "redux/workflowCloseSlice";
import { AuthContext } from "context/AuthContext";

const Closeticket = () => {
  const navigate = useNavigate();
  const [adminAccess, setAdminAccess] = useState(false);
  const { datauser } = useContext(AuthContext);
  const dispatch = useDispatch();
  const [days, setDays] = useState("");
  const [sendEmail, setSendEmail] = useState("");
  const [status, setStatus] = useState("");

  const { getWorkflowCloseResult, addWorkflowCloseResult } = useSelector(
    (state) => state.workflowClose
  );

  const get = useCallback(
    async (params) => {
      getData(
        API_URL_workflowClose,
        params,
        { dispatch, redux: workflowCloseReducers },
        "GET_WORKFLOWCLOSE"
      );
    },
    [dispatch]
  );

  const handleSubmit = (e) => {
    e.preventDefault();
    const formData = {
      days: days,
      send_email: sendEmail,
      status: status,
    };
    //edit on id 1
    putData(
      `${API_URL_workflowClose}1/`,
      formData,
      { dispatch, redux: workflowCloseReducers },
      "ADD_WORKFLOWCLOSE",
      () => {
        fetchData();
      }
    );
  };

  const fetchData = useCallback(() => {
    //get id 1 for workflow Close
    const params = `1/`;
    get(params);
  }, [get]);

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    if (addWorkflowCloseResult) {
      fetchData();
    }
  }, [addWorkflowCloseResult, fetchData]);

  useEffect(() => {
    if (getWorkflowCloseResult) {
      setDays(getWorkflowCloseResult.days);
      setSendEmail(getWorkflowCloseResult.send_email);
      setStatus(getWorkflowCloseResult.status);
    }
  }, [getWorkflowCloseResult]);

  useEffect(() => {
    if (datauser !== "") {
      const permissionViewMenuAdmin = datauser.group_permissions.includes(
        "access_menu_admin"
      );
      if (permissionViewMenuAdmin) {
        setAdminAccess(true);
      } else {
        navigate("/dashboard/agent");
      }
    }
  }, [datauser]);

  if (!adminAccess) {
    return null;
  }

  return (
    <Container>
      <Breadcrumb
        title={"Settings"}
        excludedPaths={["tickets", "administrator"]}
        group={"Superadmin"}
      />
      <div className="bg-neutral dark:bg-neutral-800 rounded overflow-hidden shadow">
        <div className="h-12 w-full grid items-center px-4 bg-neutral-100 dark:bg-neutral-700 border-b border-neutral-200 dark:border-neutral-600 text-xs md:text-base">
          Close ticket workflow settings
        </div>
        <form onSubmit={handleSubmit}>
          <div className="h-auto w-auto px-4 bg-neutral dark:bg-neutral-800 border-b border-neutral-200 dark:border-neutral-600 object-left">
            <div className="mt-4 grid grid-cols-4 gap-4">
              <div>
                <label>
                  No of days: <span className="text-red-500">*</span>
                </label>
              </div>

              <div className="col-span-3">
                <div className="h-auto w-full md:w-2/3 lg:w-2/3 grid items-center px-4 bg-white dark:bg-neutral-700 border border-gray-300 border-l-8 italic dark:border-neutral-600">
                  The number of days to after which the tickets not have
                  activity will be auto-closed.
                </div>
                <input
                  type="text"
                  name="days"
                  id="days"
                  value={days}
                  onChange={(e) => setDays(e.target.value)}
                  className="block w-full md:w-2/3 lg:w-2/3 rounded-md border border-gray-500 bg-white py-1.5 px-2 text-gray-900 shadow-sm placeholder:text-gray-400 focus:ring-1 focus:ring-blue-400 sm:text-sm sm:leading-6 mt-3"
                />
              </div>

              <div>
                <label>Send email to user:</label>
              </div>

              <div className="col-span-3">
                <div className="h-auto w-full md:w-2/3 lg:w-2/3 grid items-center px-4 bg-white dark:bg-neutral-700 border border-gray-300 border-l-8 italic dark:border-neutral-600">
                  Send email to user on auto-closing the ticket?
                </div>

                <label className="inline-flex items-center mt-3">
                  <input
                    id="sendEmail1"
                    name="sendEmail"
                    type="radio"
                    checked={sendEmail === 1}
                    onChange={(e) => setSendEmail(1)}
                    className="form-radio h-4 w-4 text-indigo-600 transition duration-150 ease-in-out"
                  />
                  <span className="ml-2">Yes</span>
                </label>
                <label className="inline-flex items-center ml-2">
                  <input
                    id="sendEmail0"
                    name="sendEmail"
                    type="radio"
                    checked={sendEmail === 0}
                    onChange={(e) => setSendEmail(0)}
                    className="form-radio h-4 w-4 text-indigo-600 transition duration-150 ease-in-out sm:ml-2 md:ml-2 lg:ml-3"
                  />
                  <span className="ml-2">No</span>
                </label>
              </div>

              <div>
                <label>Status Tiket:</label>
              </div>

              <div className="col-span-3">
                <div className="h-auto w-full md:w-2/3 lg:w-2/3 grid items-center px-4 bg-white dark:bg-neutral-700 border border-gray-300 border-l-8 italic dark:border-neutral-600">
                  Select a status to choose on closing the ticket.
                </div>
                <select
                  id="status"
                  name="status"
                  value={status}
                  onChange={(e) => setStatus(e.target.value)}
                  className="block w-1/2 rounded-md border border-gray-500 bg-white py-2 px-2 text-gray-900 shadow-sm focus:ring-1 focus:ring-inset focus:ring-blue-400 sm:text-sm sm:leading-6 mt-3 mb-8"
                >
                  <option value="">Select</option>
                  <option value="0">Resolved</option>
                  <option value="1">Closed</option>
                </select>
              </div>
            </div>
          </div>
          <div className="h-12 w-full grid items-center px-4 bg-neutral-50 dark:bg-neutral-700 border-b border-neutral-200 dark:border-neutral-600">
            <button
              type="submit"
              className="w-20 items-center p-1 px-3 rounded shadow-sm border text-white bg-blue-800 hover:bg-blue-700"
            >
              Submit
            </button>
          </div>
        </form>
      </div>
    </Container>
  );
};

export default Closeticket;
